export default __webpack_public_path__ + "static/media/ic_jamaica.0bd7f809.svg";